import API from "./axios";

const employeeJobWorkApi = {
  getSummary:       ()                       => API.get("/employee-job-work/summaries"),
  getLedger:        (employeeId)             => API.get(`/employee-job-work/${employeeId}`),
  getLedgerRange:   (employeeId, from, to)   => API.get(`/employee-job-work/${employeeId}/range?from=${from}&to=${to}`),
  exportPdf:        (employeeId, from, to)   => API.get(`/employee-job-work/${employeeId}/pdf?from=${from}&to=${to}`, { responseType: "blob" }),
  recordPayment:    (data)                   => API.post(`/employee-job-work/${data.employeeId}/payment`, {
    amount: data.amount, paymentDate: data.date, paymentMode: data.paymentMode,
    paymentReference: data.paymentReference, notes: data.notes,
  }),
  recordPaymentTds: (data)                   => API.post(`/employee-job-work/${data.employeeId}/payment-tds`, data),
  tdsPreview:       (employeeId, from, to, amount) => API.get(`/employee-job-work/${employeeId}/tds-preview?from=${from}&to=${to}${amount ? `&amount=${amount}` : ""}`),
  getReceipt:       (employeeId, entryId)    => API.get(`/employee-job-work/${employeeId}/receipt/${entryId}`, { responseType: "blob" }),
  recordAdvance:    (data)                   => API.post(`/employee-job-work/${data.employeeId}/advance`, data),
  advancePreview:   (employeeId, from, to)   => API.get(`/employee-job-work/${employeeId}/advance-preview?from=${from}&to=${to}`),
  // Fixed-salary payment — list unpaid CONFIRMED slips + pay selected ones.
  getUnpaidSalarySlips: (employeeId)         => API.get(`/employee-job-work/${employeeId}/unpaid-salary-slips`),
  recordSalaryPayment:  (data)               => API.post(`/employee-job-work/${data.employeeId}/salary-payment`, data),
  // Phase 36da.99.pd — delete a payment/advance ledger entry (reverts dependents).
  deletePayment:    (ledgerId)               => API.delete(`/employee-job-work/entry/${ledgerId}`),
};

export default employeeJobWorkApi;